/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Select from 'react-select';
// helpers
import { selectStyles } from '../../helpers';

const SelectReactWithTextManualEntry = ({
  name,
  error,
  label,
  value,
  isMulti,
  options,
  touched,
  required,
  className,
  handleBlur,
  isClearable,
  placeholder,
  handleChange,
  isSearchable,
  noOptionsMessage,
}) => {
  const [inputValue, setInputValue] = useState('');

  const getOptions = () => {
    const baseOptions = Array.isArray(options) ? options : [];

    if (inputValue && !baseOptions.some(option => option.label === inputValue)) {
      return [...baseOptions, { value: inputValue, label: inputValue }];
    }

    return baseOptions;
  };

  return (
    <>
      <div className={`form-outline mb-4 DashBoardInputBx${className ? ` ${className}` : ''}`}>
        <label id={name} className='form-label' htmlFor={name}>
          {label}
          {required && <span className='RedStar'>*</span>}
        </label>
        <Select
          name={name}
          value={value}
          isMulti={isMulti}
          onBlur={handleBlur}
          styles={selectStyles}
          options={getOptions()}
          onChange={handleChange}
          isClearable={isClearable}
          placeholder={placeholder}
          isSearchable={isSearchable}
          noOptionsMessage={noOptionsMessage}
          onInputChange={value => setInputValue(value)}
          className={`${touched && error && 'input-error-react-select'}`}
        />
        {
          touched && error && (
            <div className='text-danger'>{error}</div>
          )
        }
      </div>
    </>
  );
};

export default SelectReactWithTextManualEntry;
